import React from "react";
import ReactDOM from "react-dom";
import "./style/index.css";
import AppComponent from "./components/app-component";
import * as serviceWorker from "./serviceWorker";
import "react-app-polyfill/ie9";
import "url-search-params-polyfill";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { withTranslation } from 'react-i18next';

const AppComponentWrapped = withTranslation()(AppComponent)


i18n.on("initialized", () => {
  ReactDOM.render(
    <AppComponentWrapped/>,
  document.getElementById("root")
);
})




// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
